var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-row",
    [
      _c(
        "a-card",
        { ref: "card", staticClass: "list", attrs: { bordered: false } },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                { ref: "forum-search-form", attrs: { layout: "inline" } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: { label: _vm.language["ispforum.keyword"] }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  "max-length": 100,
                                  placeholder:
                                    _vm.language["ispforum.search.placeholder"]
                                },
                                on: {
                                  change: _vm.handleSearchChange,
                                  pressEnter: _vm.handleSearch
                                },
                                model: {
                                  value: _vm.queryParams.keyword,
                                  callback: function($$v) {
                                    _vm.$set(_vm.queryParams, "keyword", $$v)
                                  },
                                  expression: "queryParams.keyword"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.type === "tags"
                        ? _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.language["ispforum.tags"]
                                  }
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: { "default-value": 0 },
                                      on: { change: _vm.handleTagChange },
                                      model: {
                                        value: _vm.searchTag,
                                        callback: function($$v) {
                                          _vm.searchTag = $$v
                                        },
                                        expression: "searchTag"
                                      }
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: 0 } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.language["ispforum.all"])
                                          )
                                        ]
                                      ),
                                      _vm._l(_vm.tagsInfo, function(tag) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: tag.id,
                                            attrs: { value: tag.id }
                                          },
                                          [_vm._v(_vm._s(tag.title))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("a-col", { attrs: { md: 3, sm: 24 } }, [
                        _c(
                          "span",
                          { staticClass: "table-page-search-submitButtons" },
                          [
                            _c(
                              "a-tooltip",
                              {
                                attrs: {
                                  title: _vm.language["ispforum.search"],
                                  placement: "top"
                                }
                              },
                              [
                                _c("a-button", {
                                  staticStyle: { "margin-right": "16px" },
                                  attrs: { type: "primary", icon: "search" },
                                  on: { click: _vm.handleSearch }
                                })
                              ],
                              1
                            ),
                            _c(
                              "a-tooltip",
                              {
                                attrs: {
                                  title: _vm.language["ispforum.post.issue"],
                                  placement: "top"
                                }
                              },
                              [
                                _c("a-button", {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleModal }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "a-col",
                        {
                          staticStyle: { float: "right" },
                          attrs: { md: 5, sm: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("span", [_vm._v("8")]),
                              _c("a-slider", {
                                staticStyle: { width: "90%" },
                                attrs: { reverse: "", max: 8, min: 2 },
                                on: { change: _vm.handleSlider },
                                model: {
                                  value: _vm.sliderCount,
                                  callback: function($$v) {
                                    _vm.sliderCount = $$v
                                  },
                                  expression: "sliderCount"
                                }
                              }),
                              _c("span", [_vm._v("2")])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("a-spin", { attrs: { spinning: _vm.loading.list } }, [
            _vm.list.data && _vm.list.data.length > 0
              ? _c(
                  "div",
                  { staticClass: "forum-list" },
                  _vm._l(_vm.list.data, function(item, idx) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        class: item.title ? "has-title" : "no-title",
                        style:
                          "width: " +
                          _vm.listItemWidth +
                          "px; height: " +
                          _vm.listItemWidth +
                          "px;"
                      },
                      [
                        _c(
                          "a-popconfirm",
                          {
                            attrs: {
                              title:
                                _vm.language["ispforum.delete.issue.confirm"],
                              visible:
                                _vm.delId ===
                                (item.topic_id ? item.topic_id : item.id),
                              placement: "top"
                            },
                            on: {
                              visibleChange: _vm.handleDelVisibleChange,
                              cancel: _vm.handleDelCancel,
                              confirm: function($event) {
                                return _vm.handleDelSubmit(
                                  item.topic_id ? item.topic_id : item.id
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "forum-list-item",
                                class:
                                  (_vm.editId || _vm.delId) &&
                                  ((item.topic_id ? item.topic_id : item.id) ===
                                    _vm.editId ||
                                    (item.topic_id
                                      ? item.topic_id
                                      : item.id) === _vm.delId)
                                    ? "active"
                                    : "",
                                style: {
                                  background: item.bgcolor || "#ffffff"
                                },
                                on: {
                                  dblclick: function($event) {
                                    return _vm.handleDetail(item)
                                  }
                                }
                              },
                              [
                                item.title
                                  ? _c(
                                      "div",
                                      { staticClass: "forum-list-item-title" },
                                      [
                                        _c(
                                          "a-tooltip",
                                          {
                                            attrs: {
                                              title: item.title,
                                              placement: "topLeft"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.title) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "forum-list-item-content" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "forum-list-item-date" },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(item.created_at)
                                          }
                                        }),
                                        item.showImageIcon
                                          ? _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.imageIcon
                                                )
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    ),
                                    _c("div", {
                                      staticStyle: { height: "100%" },
                                      domProps: {
                                        innerHTML: _vm._s(item.pureContent)
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "forum-list-item-action" },
                                  [
                                    _c(
                                      "a-tooltip",
                                      {
                                        attrs: {
                                          title:
                                            _vm.language["ispforum.details"],
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("a-icon", {
                                          staticStyle: { color: "#1890FF" },
                                          attrs: { type: "message" },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleDetail(item)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-popover",
                                      {
                                        key: item.id,
                                        attrs: {
                                          placement: "bottom",
                                          trigger: "click",
                                          arrowPointAtCenter: true
                                        },
                                        on: {
                                          visibleChange: function($event) {
                                            return _vm.handleTopicTagVisible(
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("a-icon", {
                                          staticStyle: { color: "#1890FF" },
                                          attrs: { type: "tag" }
                                        }),
                                        _c(
                                          "template",
                                          { slot: "content" },
                                          [
                                            _c(
                                              "a-spin",
                                              {
                                                attrs: {
                                                  spinning: _vm.loading.tag
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "forum-tags" },
                                                  [
                                                    _c(
                                                      "ul",
                                                      [
                                                        _vm.tagsInfo.length > 0
                                                          ? _c(
                                                              "a-checkbox-group",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.tagChecked
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.handleTopicTag
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.tagsInfo,
                                                                function(tag) {
                                                                  return _c(
                                                                    "li",
                                                                    {
                                                                      key:
                                                                        tag.id
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a-checkbox",
                                                                        {
                                                                          attrs: {
                                                                            value:
                                                                              tag.id,
                                                                            disabled:
                                                                              tag.user_id !==
                                                                              _vm
                                                                                .userInfo
                                                                                .id
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                " +
                                                                              _vm._s(
                                                                                tag.title
                                                                              ) +
                                                                              "\n                                                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _c("a-empty")
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "forum-tags-add"
                                                      },
                                                      [
                                                        _c("a-input", {
                                                          staticStyle: {
                                                            width: "160px",
                                                            "margin-right":
                                                              "8px"
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              _vm.language[
                                                                "ispforum.tags.name"
                                                              ],
                                                            "max-length": 10
                                                          },
                                                          model: {
                                                            value: _vm.tagName,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.tagName = $$v
                                                            },
                                                            expression:
                                                              "tagName"
                                                          }
                                                        }),
                                                        _c(
                                                          "a-tooltip",
                                                          {
                                                            attrs: {
                                                              title:
                                                                _vm.language[
                                                                  "ispforum.tags.add"
                                                                ]
                                                            }
                                                          },
                                                          [
                                                            _c("a-button", {
                                                              attrs: {
                                                                type: "primary",
                                                                icon: "plus"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCreateTag(
                                                                    item.topic_id
                                                                      ? item.topic_id
                                                                      : item.id
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "forum-tags-manage"
                                                      },
                                                      [
                                                        _c(
                                                          "a-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              icon: "tags",
                                                              ghost: ""
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.handleTagsVisible
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.language[
                                                                  "ispforum.tags.manage"
                                                                ]
                                                              ) +
                                                                "\n                                                    "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "a-tooltip",
                                      {
                                        attrs: {
                                          title: item.is_subscription
                                            ? _vm.language[
                                                "ispforum.unsubscribe"
                                              ]
                                            : _vm.language[
                                                "ispforum.subscribe"
                                              ],
                                          placement: "top"
                                        }
                                      },
                                      [
                                        !item.is_subscription
                                          ? _c("a-icon", {
                                              staticStyle: { color: "#e9860f" },
                                              attrs: { type: "star" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleSubscription(
                                                    item.topic_id
                                                      ? item.topic_id
                                                      : item.id,
                                                    idx,
                                                    1
                                                  )
                                                }
                                              }
                                            })
                                          : _c("a-icon", {
                                              staticStyle: { color: "#e9860f" },
                                              attrs: {
                                                type: "star",
                                                theme: "filled"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleSubscription(
                                                    item.topic_id
                                                      ? item.topic_id
                                                      : item.id,
                                                    idx
                                                  )
                                                }
                                              }
                                            })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-popover",
                                      {
                                        attrs: {
                                          title: "選色板",
                                          trigger: "click",
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _c("template", { slot: "content" }, [
                                          _c(
                                            "ul",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "list-style-type": "none",
                                                padding: "8px 8px 0px 8px"
                                              }
                                            },
                                            _vm._l(_vm.bgColorList, function(
                                              bgColor,
                                              i
                                            ) {
                                              return _c("li", { key: i }, [
                                                _c("div", {
                                                  staticClass:
                                                    "forum-list-item-bg",
                                                  style: {
                                                    background: bgColor
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleBgColor(
                                                        bgColor,
                                                        item
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            }),
                                            0
                                          )
                                        ]),
                                        _c(
                                          "a-tooltip",
                                          {
                                            attrs: {
                                              title:
                                                _vm.language[
                                                  "ispforum.bgColor"
                                                ],
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c("a-icon", {
                                              staticStyle: { color: "#ff4d4d" },
                                              attrs: { type: "bg-colors" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    ),
                                    item.can_edit
                                      ? _c(
                                          "a-dropdown",
                                          {
                                            attrs: {
                                              "destroy-popup-on-hide": true,
                                              placement: "bottomCenter"
                                            }
                                          },
                                          [
                                            _c("a-icon", {
                                              staticStyle: { color: "#1890FF" },
                                              attrs: { type: "menu" }
                                            }),
                                            _c(
                                              "a-menu",
                                              {
                                                attrs: { slot: "overlay" },
                                                slot: "overlay"
                                              },
                                              [
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "edit",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleEdit(
                                                          item.topic_id
                                                            ? item.topic_id
                                                            : item.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "edit" }
                                                    }),
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.language[
                                                          "ispforum.edit"
                                                        ]
                                                      ) +
                                                        "\n                                        "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "del",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.delId = item.topic_id
                                                          ? item.topic_id
                                                          : item.id
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "delete" }
                                                    }),
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.language[
                                                          "ispforum.delete"
                                                        ]
                                                      ) +
                                                        "\n                                        "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticClass: "forum-list-empty" },
                  [_c("a-empty")],
                  1
                )
          ]),
          _vm.list.data && _vm.list.data.length > 0
            ? _c("a-pagination", {
                attrs: {
                  total: _vm.list.total,
                  "page-size-options": _vm.pageSizeOptions,
                  "page-size": _vm.pagination.pageSize,
                  "show-quick-jumper": "",
                  "show-size-changer": ""
                },
                on: {
                  showSizeChange: _vm.onShowSizeChange,
                  change: _vm.onPageChange
                },
                model: {
                  value: _vm.pagination.page,
                  callback: function($$v) {
                    _vm.$set(_vm.pagination, "page", $$v)
                  },
                  expression: "pagination.page"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "j-modal",
        {
          attrs: {
            visible: _vm.visible.topics,
            width: "60%",
            centered: true,
            title:
              (_vm.editId
                ? _vm.language["ispforum.update"]
                : _vm.language["ispforum.post"]) +
              _vm.language["ispforum.issue"],
            maskClosable: false,
            "wrap-class-name":
              _vm.innerFullscreen === false ? "ispforum-modal" : null,
            footer: null
          },
          on: {
            cancel: _vm.handleModal,
            setInnerFullscreen: _vm.setInnerFullscreen
          }
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.editId && _vm.loading.update } },
            [
              _c(
                "a-form-model",
                {
                  ref: "forum-post-form",
                  staticClass: "form",
                  attrs: {
                    model: _vm.forumForm.validate,
                    rules: _vm.forumForm.rules
                  }
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["ispforum.title"],
                                prop: "title",
                                labelCol: { span: 4 },
                                wrapperCol: { span: 18 }
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  "max-length": 100,
                                  placeholder:
                                    _vm.language["ispforum.title.input"]
                                },
                                model: {
                                  value: _vm.forumForm.validate.title,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.forumForm.validate,
                                      "title",
                                      $$v
                                    )
                                  },
                                  expression: "forumForm.validate.title"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["ispforum.content"],
                                prop: "content",
                                labelCol: { span: 4 },
                                wrapperCol: { span: 18 }
                              }
                            },
                            [
                              _c("j-editor", {
                                attrs: {
                                  "upload-source": "ipsys",
                                  limit: _vm.limitNum
                                },
                                model: {
                                  value: _vm.forumForm.validate.content,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.forumForm.validate,
                                      "content",
                                      $$v
                                    )
                                  },
                                  expression: "forumForm.validate.content"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    {
                      staticClass: "form-row",
                      staticStyle: { "padding-bottom": "16px" },
                      attrs: {
                        type: "flex",
                        align: "middle",
                        justify: "center"
                      }
                    },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-right": "16px" },
                          on: { click: _vm.handleModal }
                        },
                        [_vm._v(_vm._s(_vm.language["ispforum.cancel"]))]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handlePost }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.editId
                                  ? _vm.language["ispforum.update"]
                                  : _vm.language["ispforum.post"]
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "j-modal",
        {
          attrs: {
            visible: _vm.visible.detail,
            width: "70%",
            centered: true,
            "wrap-class-name":
              _vm.innerFullscreen === false ? "ispforum-modal" : null,
            switchFullscreen: "",
            title: _vm.language["ispforum.issue.details"],
            maskClosable: false,
            wrapClassName: "detail-info",
            footer: null
          },
          on: {
            cancel: _vm.handleDetail,
            setInnerFullscreen: _vm.setInnerFullscreen
          }
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading.discuss } },
            [
              _c(
                "a-form-model",
                { staticClass: "form" },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            { attrs: { label: "" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  size: "large",
                                  disabled: "",
                                  readOnly: ""
                                },
                                model: {
                                  value: _vm.detailInfo.title,
                                  callback: function($$v) {
                                    _vm.$set(_vm.detailInfo, "title", $$v)
                                  },
                                  expression: "detailInfo.title"
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "detail-icons" },
                                [
                                  _c(
                                    "a-tooltip",
                                    {
                                      attrs: {
                                        title: _vm.detailInfo.is_subscription
                                          ? _vm.language["ispforum.unsubscribe"]
                                          : _vm.language["ispforum.subscribe"],
                                        placement: "top"
                                      }
                                    },
                                    [
                                      !_vm.detailInfo.is_subscription
                                        ? _c("a-icon", {
                                            staticStyle: { color: "#e9860f" },
                                            attrs: { type: "star" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleSubscription(
                                                  _vm.detailInfo.id,
                                                  "detail",
                                                  1
                                                )
                                              }
                                            }
                                          })
                                        : _c("a-icon", {
                                            staticStyle: { color: "#e9860f" },
                                            attrs: {
                                              type: "star",
                                              theme: "filled"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleSubscription(
                                                  _vm.detailInfo.id,
                                                  "detail"
                                                )
                                              }
                                            }
                                          })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-popover",
                                    {
                                      key: _vm.detailInfo.id,
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        arrowPointAtCenter: true
                                      },
                                      on: {
                                        visibleChange: function($event) {
                                          return _vm.handleTopicTagVisible(
                                            _vm.detailInfo
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("a-icon", {
                                        staticStyle: { color: "#1890FF" },
                                        attrs: { type: "tag" }
                                      }),
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _c(
                                            "a-spin",
                                            {
                                              attrs: {
                                                spinning: _vm.loading.tag
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "forum-tags" },
                                                [
                                                  _c(
                                                    "ul",
                                                    [
                                                      _c(
                                                        "a-checkbox-group",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.tagChecked
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleTopicTag
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.tagsInfo,
                                                          function(tag) {
                                                            return _c(
                                                              "li",
                                                              { key: tag.id },
                                                              [
                                                                _c(
                                                                  "a-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        tag.id
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                                " +
                                                                        _vm._s(
                                                                          tag.title
                                                                        ) +
                                                                        "\n                                                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "forum-tags-add"
                                                    },
                                                    [
                                                      _c("a-input", {
                                                        staticStyle: {
                                                          width: "160px",
                                                          "margin-right": "8px"
                                                        },
                                                        attrs: {
                                                          placeholder:
                                                            _vm.language[
                                                              "ispforum.tags.name"
                                                            ],
                                                          "max-length": 100
                                                        },
                                                        model: {
                                                          value: _vm.tagName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.tagName = $$v
                                                          },
                                                          expression: "tagName"
                                                        }
                                                      }),
                                                      _c(
                                                        "a-tooltip",
                                                        {
                                                          attrs: {
                                                            title:
                                                              _vm.language[
                                                                "ispforum.tags.add"
                                                              ]
                                                          }
                                                        },
                                                        [
                                                          _c("a-button", {
                                                            attrs: {
                                                              type: "primary",
                                                              icon: "plus"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.handleCreateTag(
                                                                  _vm.detailInfo
                                                                    .id
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "forum-tags-manage"
                                                    },
                                                    [
                                                      _c(
                                                        "a-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            icon: "tags",
                                                            ghost: ""
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleTagsVisible
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.language[
                                                                  "ispforum.tags.manage"
                                                                ]
                                                              ) +
                                                              "\n                                                    "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  ),
                                  _c(
                                    "a-tooltip",
                                    {
                                      attrs: {
                                        title:
                                          _vm.language[
                                            "ispforum.issue.participate"
                                          ],
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("a-icon", {
                                        staticStyle: { color: "#1890ff" },
                                        attrs: {
                                          type: "plus-circle",
                                          theme: "filled"
                                        },
                                        on: { click: _vm.handleTopicComment }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm.detailInfo.user_id == _vm.userInfo.id &&
                                  !_vm.detailInfo.is_gives &&
                                  _vm.detailInfo.can_edit &&
                                  (!_vm.detailInfo.commentslist ||
                                    !_vm.detailInfo.commentslist.length)
                                    ? _c(
                                        "a-tooltip",
                                        {
                                          attrs: {
                                            title: _vm.language["common.edit"],
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("a-icon", {
                                            staticStyle: { color: "#1890ff" },
                                            attrs: { type: "edit" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleEdit(
                                                  _vm.detailInfo.id,
                                                  true
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.visible.comments
                            ? _c(
                                "a-form-model-item",
                                { attrs: { label: "" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "detail-info-comment" },
                                    [
                                      _c("j-editor", {
                                        attrs: {
                                          "upload-source": "ipsys",
                                          limit: 5000,
                                          height: 200
                                        },
                                        model: {
                                          value: _vm.comment.content,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.comment,
                                              "content",
                                              $$v
                                            )
                                          },
                                          expression: "comment.content"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "detail-info-comment-btns"
                                        },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "check"
                                              },
                                              on: {
                                                click:
                                                  _vm.handleCreateOrUpdateComment
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.comment.isEdit
                                                      ? _vm.language[
                                                          "ispforum.update"
                                                        ]
                                                      : _vm.language[
                                                          "ispforum.post"
                                                        ]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              attrs: { icon: "close" },
                                              on: {
                                                click: _vm.handleTopicComment
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.language[
                                                    "ispforum.cancel"
                                                  ]
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c("a-form-model-item", { attrs: { label: "" } }, [
                            _c("div", { staticClass: "detail-info-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "detail-info-item-name0",
                                  staticStyle: {
                                    width: "190px",
                                    "flex-direction": "column"
                                  }
                                },
                                [
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.detailInfo.nickname ||
                                          _vm.detailInfo.sys_user_name
                                      )
                                    }
                                  }),
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          _vm._s(_vm.detailInfo.created_at)
                                        )
                                      ]),
                                      _c("p", {
                                        staticClass: "date",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.detailInfo.created_at
                                          )
                                        }
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _c("div", {
                                staticClass: "detail-info-item-content",
                                staticStyle: { width: "calc(100% - 264px)" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.detailInfo.content)
                                },
                                on: { click: _vm.handleTopicContentClick }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "detail-info-item-like",
                                  staticStyle: { width: "64px" }
                                },
                                [
                                  !_vm.detailInfo.is_gives
                                    ? _c(
                                        "a-tooltip",
                                        {
                                          attrs: {
                                            title: _vm.language["ispforum.like"]
                                          }
                                        },
                                        [
                                          _c("a-icon", {
                                            staticStyle: { color: "#f5222d" },
                                            attrs: { type: "like" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleTopicAndCommentLike(
                                                  1,
                                                  _vm.detailInfo.id,
                                                  1
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "a-tooltip",
                                        {
                                          attrs: {
                                            title:
                                              _vm.language["ispforum.unlike"]
                                          }
                                        },
                                        [
                                          _c("a-icon", {
                                            staticStyle: { color: "#f5222d" },
                                            attrs: {
                                              type: "like",
                                              theme: "filled"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleTopicAndCommentLike(
                                                  1,
                                                  _vm.detailInfo.id,
                                                  0
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            ])
                          ]),
                          _c("a-form-model-item", { attrs: { label: "" } }, [
                            _c(
                              "div",
                              { staticClass: "details-isorter" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    style: {
                                      color:
                                        _vm.comment.orderSort == "desc"
                                          ? " #1890FF"
                                          : "#000000a6"
                                    },
                                    attrs: { type: "link" },
                                    on: {
                                      click: function() {
                                        _vm.comment.orderSort = "desc"
                                        _vm.handleCommentSort()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.language[
                                            "ispforum.publishedNewToOld"
                                          ]
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _c("a-divider", {
                                  attrs: { type: "vertical" }
                                }),
                                _c(
                                  "a-button",
                                  {
                                    style: {
                                      color:
                                        _vm.comment.orderSort == "desc"
                                          ? "#000000a6"
                                          : " #1890FF"
                                    },
                                    attrs: { type: "link" },
                                    on: {
                                      click: function() {
                                        _vm.comment.orderSort = "asc"
                                        _vm.handleCommentSort()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.language[
                                            "ispforum.publishedOldToNew"
                                          ]
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "a-form-model-item",
                            { attrs: { label: "" } },
                            [
                              _vm.commentsList && _vm.commentsList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "detail-info-items" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "detail-info-item",
                                          staticStyle: {
                                            width: "100%",
                                            display: "flex",
                                            "flex-direction": "column"
                                          }
                                        },
                                        [
                                          _c("child-comment-iterate", {
                                            attrs: {
                                              comment: _vm.commentsList,
                                              handleTopicContentClick:
                                                _vm.handleTopicContentClick,
                                              handleTopicAndCommentLike:
                                                _vm.handleTopicAndCommentLike,
                                              handleCreateOrUpdateComment:
                                                _vm.handleCreateOrUpdateComment,
                                              change: _vm.handleChildComments
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _c("a-empty", {
                                    staticClass: "detail-info-no-comments",
                                    attrs: {
                                      description:
                                        _vm.language["ispforum.comment.not"]
                                    }
                                  })
                            ],
                            1
                          ),
                          _vm.comment.total > 0
                            ? _c("a-pagination", {
                                attrs: {
                                  total: _vm.comment.total,
                                  "page-size-options": _vm.pageSizeOptions,
                                  "page-size": _vm.comment.pagination.pageSize,
                                  "show-quick-jumper": "",
                                  "show-size-changer": ""
                                },
                                on: {
                                  showSizeChange:
                                    _vm.onShowSizeChangeForComment,
                                  change: _vm.onPageChangeForComment
                                },
                                model: {
                                  value: _vm.comment.pagination.page,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.comment.pagination,
                                      "page",
                                      $$v
                                    )
                                  },
                                  expression: "comment.pagination.page"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            width: 520,
            "z-index": 1031,
            "mask-closable": false,
            "wrap-class-name": "tags-manage",
            "destroy-on-close": true,
            footer: null
          },
          on: {
            cancel: function($event) {
              _vm.tagManageCheckedObj = {}
            }
          },
          model: {
            value: _vm.visible.labels,
            callback: function($$v) {
              _vm.$set(_vm.visible, "labels", $$v)
            },
            expression: "visible.labels"
          }
        },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.language["ispforum.tags.manage"]) +
                  "\n            "
              ),
              _c(
                "a-popconfirm",
                {
                  attrs: {
                    title: _vm.language["ispforum.tags.delete"],
                    overlayStyle: { zIndex: 1040 }
                  },
                  on: { confirm: _vm.handleTopicTagRemove }
                },
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "16px" },
                      attrs: { type: "danger" }
                    },
                    [_vm._v(_vm._s(_vm.language["ispforum.delete"]))]
                  )
                ],
                1
              ),
              _c("a-divider", { attrs: { type: "vertical" } }),
              _c("a-input", {
                staticStyle: { width: "180px" },
                attrs: {
                  "max-length": 100,
                  placeholder: _vm.language["ispforum.selectTagEdit"]
                },
                model: {
                  value: _vm.tagManageCheckedObj.title,
                  callback: function($$v) {
                    _vm.$set(_vm.tagManageCheckedObj, "title", $$v)
                  },
                  expression: "tagManageCheckedObj.title"
                }
              }),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleTopicTagRevise }
                },
                [_vm._v(_vm._s(_vm.language["common.revise"]))]
              )
            ],
            1
          ),
          _c(
            "a-spin",
            {
              staticClass: "tags-manage-list",
              attrs: { spinning: _vm.loading.tag }
            },
            [
              _c(
                "ul",
                [
                  _vm.tagsInfo.length > 0
                    ? _c(
                        "a-checkbox-group",
                        {
                          on: { change: _vm.handleTopicTagManage },
                          model: {
                            value: _vm.tagManageChecked,
                            callback: function($$v) {
                              _vm.tagManageChecked = $$v
                            },
                            expression: "tagManageChecked"
                          }
                        },
                        _vm._l(_vm.tagsInfo, function(tag) {
                          return _c(
                            "li",
                            { key: tag.id },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  attrs: {
                                    value: tag.id,
                                    disabled: tag.user_id !== _vm.userInfo.id
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(tag.title) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("a-empty")
                ],
                1
              )
            ]
          )
        ],
        2
      ),
      _c(
        "j-modal",
        {
          attrs: {
            visible: _vm.visible.media,
            width: "80%",
            centered: true,
            "wrap-class-name":
              _vm.innerFullscreen === false ? "ispforum-modal" : null,
            zIndex: 1031,
            title: _vm.language["ispforum.preview"],
            "mask-closable": true,
            "destroy-on-close": true,
            footer: null
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.visible, "media", $event)
            },
            setInnerFullscreen: _vm.setInnerFullscreen
          }
        },
        [
          _c("div", {
            staticClass: "ispforum-preview",
            domProps: { innerHTML: _vm._s(_vm.preview) }
          })
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.commentVisible,
            "destroy-on-close": true,
            footer: null,
            closable: false
          }
        },
        [
          _c(
            "div",
            { staticClass: "detail-info-comment" },
            [
              _c("j-editor", {
                model: {
                  value: _vm.childCommentObj.content2,
                  callback: function($$v) {
                    _vm.$set(_vm.childCommentObj, "content2", $$v)
                  },
                  expression: "childCommentObj.content2"
                }
              }),
              _c(
                "div",
                { staticClass: "detail-info-comment-btns" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "check" },
                      on: {
                        click: function(e) {
                          _vm.handleCreateOrUpdateComment(
                            _vm.childCommentObj.pid,
                            _vm.childCommentObj.content2,
                            function() {
                              _vm.commentVisible = false
                              _vm.childCommentObj.content2 = null
                              this$1.$forceUpdate()
                            }
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.language["ispforum.post"]) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { icon: "close" },
                      on: {
                        click: function() {
                          _vm.commentVisible = false
                          _vm.childCommentObj.content2 = null
                          this$1.$forceUpdate()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.language["ispforum.cancel"]) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }